<template>
<main-content v-if="$can('read', 'ipg-gateway')">
    <manage-dedicated></manage-dedicated>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import ManageDedicated from './components/manage-dedicated'

export default {
    components: {
        'main-content': mainContent,
        'manage-dedicated': ManageDedicated,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
}
</script>

<style>

</style>